import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { SDKOptions, SportTypes } from '../../types';
import { generateRequest } from '../http.service';

export interface IRankingProps {
  rankingId: string;
  offset: number;
  limit: number;
  countryId: string;
}

export interface IAvailableRankingsProps {
  standingTypeSubcategory: string;
}

export const getRanking = async ({ params, sdkOptions }: { params: IRankingProps; sdkOptions: SDKOptions }) => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/${SportTypes.TENNIS}/v2/rankings/${params.rankingId}`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    offset: params.offset,
    limit: params.limit,
    country_id: params.countryId,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};

export const getAvailableRankings = async ({ params, sdkOptions }: { params: IAvailableRankingsProps; sdkOptions: SDKOptions }) => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/${SportTypes.TENNIS}/v2/rankings/available`;

  const baseParams = {
    standing_type_subcategory: params.standingTypeSubcategory,
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    scope: 'CURRENT',
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
